import { TRANSIENT_QUERY_PARAMS } from '@/shared/components/ui/data-table/hooks/use-filter-params/use-filter-params.constants';

export const toPersistableQuery = (
  searchParams: URLSearchParams,
  unsavedParams: readonly string[] = [],
): string => {
  const params = new URLSearchParams(searchParams);
  [...TRANSIENT_QUERY_PARAMS, ...unsavedParams].forEach((param) =>
    params.delete(param),
  );

  return params.toString();
};

// A deep link wins over the remembered view, the same rule per-param defaults follow.
export const hasPersistableParams = (searchParams: URLSearchParams): boolean =>
  Array.from(searchParams.keys()).some(
    (key) => !TRANSIENT_QUERY_PARAMS.includes(key),
  );
